import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { TransitionUrls } from '../transition-urls';

export interface SignupNoticeModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-signup-notice-modal',
  templateUrl: './signup-notice-modal.component.html',
  styleUrls: ['./signup-notice-modal.component.css']
})
export class SignupNoticeModalComponent extends DialogComponent<SignupNoticeModalModel, string> implements OnInit {
  title: string;
  data: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    setTimeout(function () {
      document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
  }

  /** Primary CTA: go to the OpenLM Cloud free-trial sign up. */
  signUp() {
    window.open(TransitionUrls.signUp, '_blank');
  }

  /**
   * "Already have an account?" — region login. We must capture the real sign-in
   * email, so signal the opener to launch the parser login form (after sign in the
   * LogIn notice modal redirects to the cloud with the email).
   */
  loginRegion(_region: string) {
    this.result = 'OPEN_LOGIN';
    this.close();
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/signup-notice-modal.component.ts